module.exports = __webpack_public_path__ + "static/media/tv.d1412347.svg";